import React, { useEffect, useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactMe.css';

function RevealBlock({ children, className = '' }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const currentRef = ref.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setVisible(entry.isIntersecting);
            },
            { threshold: 0.2 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <div
            ref={ref}
            className={`${className} ${visible ? 'contact-visible' : 'contact-hidden'}`}
        >
            {children}
        </div>
    );
}

export default function ContactMe() {
    const [form, setForm] = useState({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState('');
    const [statusType, setStatusType] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.send(
            'service_wfr9i9f',
            'template_xv236gr',
            {
                from_name: form.name,
                from_email: form.email,
                company: form.company,
                subject: form.subject,
                message: form.message
            },
            'k6rCQaeveSoIP8L3W'
        )
        .then(() => {
            setStatus('Message sent successfully!');
            setStatusType('success');
            setForm({
                name: '',
                email: '',
                company: '',
                subject: '',
                message: ''
            });
        })
        .catch(() => {
            setStatus('Failed to send message. Please try again.');
            setStatusType('error');
        });
    };

    return (
        <div className="contact-container">
            <RevealBlock className="contact-shell">
                <div className="contact-info glass-panel">
                    <p className="contact-kicker">Contact</p>
                    <h1 className="contact-title">Let’s Connect</h1>
                    <p className="contact-subheader">
                        Reach out for opportunities, collaborations, project discussions,
                        or just to connect professionally.
                    </p>

                    <div className="contact-direct">
                        <p>
                            <span>📧</span>
                            <a href="mailto:booganimben04@gmail.com">
                                booganimben04@gmail.com
                            </a>
                        </p>

                        <p>
                            <span>📱</span>
                            <a href="tel:4254354674">
                                425-435-4674
                            </a>
                        </p>
                    </div>
                </div>

                <form className="contact-form glass-panel" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="text"
                        name="company"
                        placeholder="Company / University"
                        value={form.company}
                        onChange={handleChange}
                    />

                    <input
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        value={form.subject}
                        onChange={handleChange}
                        required
                    />

                    <textarea
                        name="message"
                        placeholder="Your Message"
                        value={form.message}
                        onChange={handleChange}
                        required
                        rows={6}
                    />

                    <button className="send-btn" type="submit">
                        Send Message
                    </button>

                    {status && (
                        <p className={`status-msg ${statusType}`}>
                            {status}
                        </p>
                    )}
                </form>
            </RevealBlock>
        </div>
    );
}